import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, IconButton } from '@material-ui/core';
import { alpha, makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import clsx from 'clsx';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CmtDrawer from '../../../../../../@coremat/CmtDrawer';
import Settings from './Settings';
import SidebarSearch from '../../../../../../components/sidebar/SidebarSearch';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
	},
	actionSidebar: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '24px 5px',
		width: 65,
		borderRight: `1px solid ${theme.palette.divider}`,
	},
	contentArea: {
		width: 300,
		[theme.breakpoints.up('sm')]: {
			width: 557,
		},
	},
	scrollbarRoot: {
		height: '100vh',
		padding: 30,
	},
	iconBtn: {
		position: 'relative',
		color: alpha(theme.palette.common.dark, 0.38),
		'&:hover, &:focus, &.active': {
			color: theme.palette.primary.main,
			backgroundColor: alpha(theme.palette.primary.main, 0.08),
		},
	},
	counterRoot: {
		color: theme.palette.common.white,
		border: `solid 1px ${theme.palette.common.white}`,
		backgroundColor: theme.palette.warning.main,
		width: 20,
	},
}));

const ActionBarDrawer = ({ activeOption, onIconClick, onDrawerClose, ...rest }) => {
	const classes = useStyles();
	const location = useLocation();

	// close drawer on every route change
	useEffect(() => {
		onDrawerClose();
	}, [location]);

	return (
		<CmtDrawer data-id='actionBarDrawer' variant='temporary' anchor='left' onClose={onDrawerClose} {...rest}>
			<Box className={clsx(classes.root)}>
				<Box className={classes.actionSidebar}>
					<IconButton className={classes.iconBtn} onClick={onDrawerClose}>
						<CloseIcon />
					</IconButton>

					<IconButton
						className={clsx(classes.iconBtn, {
							active: activeOption === 'search',
						})}
						onClick={() => onIconClick('search')}
					>
						<SearchIcon />
					</IconButton>

				</Box>
				<Box className={classes.contentArea}>
					<PerfectScrollbar className={classes.scrollbarRoot}>
						{activeOption === 'search' && <SidebarSearch onSearchResultItemClicked={onDrawerClose} />}
						{activeOption === 'settings' && <Settings />}
					</PerfectScrollbar>
				</Box>
			</Box>
		</CmtDrawer>
	);
};

export default ActionBarDrawer;
